import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import SpecialHandlingIndMappingContMain from "presentation/view/container/SpecialHandlingIndMapping/SpecialHandlingIndMappingContMain";
CommonEntrypoint(<SpecialHandlingIndMappingContMain/>)